<button 
  type="button"
  class="camera-btn"
  (click)="toggleCameraModal()"
  (keyup.enter)="toggleCameraModal()"
  (keyup.space)="toggleCameraModal()"
  tabindex="0"
  aria-label="Open scanner"
  aria-label="Toggle scanner"
  [attr.aria-busy]="scannerState.currentState.scanning"
  [attr.aria-live]="scannerState.currentState.scanning ? 'polite' : null"
  [disabled]="scannerState.currentState.scanning && !showCameraModal"
>
  <span class="camera-icon" aria-hidden="true">📷</span>
  <span class="btn-text">Scan</span>
  <span class="attempt-counter" *ngIf="scannerState.currentState.scanning">
    ({{ scannerState.currentState.currentAttempt }}/{{ config.maxAttempts }})
  </span>
</button>

<div class="modal-overlay" 
     *ngIf="showCameraModal" 
     (click)="toggleCameraModal()"
     (keyup.escape)="toggleCameraModal()"
     tabindex="0"
     role="button"
     aria-label="Close scanner modal">
  <div class="modal-content" (click)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()" tabindex="0">
    <div class="modal-header">
      <div alt="Scanner modal"></div>
      <button 
        class="close-btn" 
        (click)="toggleCameraModal()"
        (keyup.enter)="toggleCameraModal()"
        (keyup.space)="toggleCameraModal()"
        tabindex="0"
        aria-label="Close scanner"
      >
        ×
      </button>
    </div>
    
    <div class="scanner-container">
      <video #video autoplay muted playsinline></video>
      <div #overlay class="overlay-box"></div>
      <div class="controls">
        <button class="zoom-btn" (click)="toggleZoom()">
          {{ getZoomLabel() }}
        </button>
        <button class="torch-btn" 
          *ngIf="scannerState.currentState.torchSupported"
          (click)="toggleTorch()">
            <span class="torch-icon">🔦</span>
        </button>
        <div class="scan-status" [ngClass]="{
            'idle': scannerState.currentState.status.includes('Scanning'),
            'success': scannerState.currentState.status.includes('Found'),
            'error': scannerState.currentState.status.includes('error') || scannerState.currentState.status.includes('failed')}">
            <span class="dot" *ngIf="scannerState.currentState.scanning"></span>
            {{ scannerState.currentState.status }}
        </div>
      </div>
    </div>

    <div class="modal-actions">
      <button 
        class="action-btn primary"
        *ngIf="!scannerState.currentState.scanning"
        (click)="startScan()"
        (keyup.enter)="startScan()"
        tabindex="0"
      >
        Start Scanning
      </button>
      <button 
        class="action-btn secondary"
        (click)="toggleCameraModal()"
        (keyup.enter)="toggleCameraModal()"
        tabindex="0"
      >
        Close
      </button>
    </div>

    <div 
      class="raw-results-toggle" 
      (click)="showRawResults = !showRawResults"
      (keyup.enter)="showRawResults = !showRawResults"
      tabindex="0"
      role="button"
    >
      {{ showRawResults ? 'Hide' : 'Show' }} Scan History ({{ scannerState.currentState.attempts.length }})
    </div>

    <div class="raw-results-container" *ngIf="showRawResults && scannerState.currentState.attempts.length">
      <div class="scan-attempt" *ngFor="let attempt of scannerState.currentState.attempts; let i = index">
        <div class="attempt-header">
          <span class="attempt-number">Attempt #{{ scannerState.currentState.attempts.length - i }}</span>
          <span class="attempt-time">{{ attempt.timestamp | date:'HH:mm:ss' }}</span>
          <button 
            class="use-result-btn"
            (click)="useScanResult(attempt)"
            (keyup.enter)="useScanResult(attempt)"
            tabindex="0"
          >
            Use this result
          </button>
        </div>
        <div class="attempt-image" *ngIf="attempt.image">
          <img [src]="attempt.image" alt="Scanned frame" />
        </div>
        <pre [innerHTML]="attempt.text | highlightMatches"></pre>
      </div>
    </div>
  </div>
</div>